import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const GET_PROMPTS_REQUEST = "GET_PROMPTS_REQUEST";
export const GET_PROMPTS_SUCCESS = "GET_PROMPTS_SUCCESS";
export const GET_PROMPTS_FAILURE = "GET_PROMPTS_FAILURE";

export const GET_PROMPT_DETAILS_REQUEST = "GET_PROMPT_DETAILS_REQUEST";
export const GET_PROMPT_DETAILS_SUCCESS = "GET_PROMPT_DETAILS_SUCCESS";
export const GET_PROMPT_DETAILS_FAILURE = "GET_PROMPT_DETAILS_FAILURE";

export const CREATE_PROMPT_REQUEST = "CREATE_PROMPT_REQUEST";
export const CREATE_PROMPT_SUCCESS = "CREATE_PROMPT_SUCCESS";
export const CREATE_PROMPT_FAILURE = "CREATE_PROMPT_FAILURE";

export const UPDATE_PROMPT_REQUEST = "UPDATE_PROMPT_REQUEST";
export const UPDATE_PROMPT_SUCCESS = "UPDATE_PROMPT_SUCCESS";
export const UPDATE_PROMPT_FAILURE = "UPDATE_PROMPT_FAILURE";

export const DELETE_PROMPT_REQUEST = "DELETE_PROMPT_REQUEST";
export const DELETE_PROMPT_SUCCESS = "DELETE_PROMPT_SUCCESS";
export const DELETE_PROMPT_FAILURE = "DELETE_PROMPT_FAILURE";

export const getPrompts = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_PROMPTS_REQUEST });
      const url = `${BASE_URL}/aiacemed/list/v1`;
      const response = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch({ type: GET_PROMPTS_SUCCESS, payload: response.data });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_PROMPTS_FAILURE, payload: error.message });
      toast.error(error?.response?.data?.message || "Failed to fetch prompts", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
};

export const getPromptDetails = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_PROMPT_DETAILS_REQUEST });
      // Fetch all prompts and filter by ID (backend doesn't have single prompt endpoint)
      const url = `${BASE_URL}/aiacemed/list/v1`;
      const response = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      const prompt = response.data.data?.find((p) => p._id === id);
      if (prompt) {
        dispatch({ type: GET_PROMPT_DETAILS_SUCCESS, payload: { data: prompt } });
      } else {
        throw new Error("Prompt not found");
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_PROMPT_DETAILS_FAILURE, payload: error.message });
      toast.error(error?.response?.data?.message || "Failed to fetch prompt details", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
};

export const createPrompt = (data, navigate) => {
  return async (dispatch) => {
    try {
      dispatch({ type: CREATE_PROMPT_REQUEST });
      const url = `${BASE_URL}/aiacemed/create/v1`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch({ type: CREATE_PROMPT_SUCCESS, payload: response.data });
      toast.success("Prompt created successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      navigate("/prompts/list");
    } catch (error) {
      console.error(error);
      dispatch({ type: CREATE_PROMPT_FAILURE, payload: error.message });
      toast.error(error?.response?.data?.message || "Failed to create prompt", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
};

export const updatePrompt = (id, data, navigate) => {
  return async (dispatch) => {
    try {
      dispatch({ type: UPDATE_PROMPT_REQUEST });
      const url = `${BASE_URL}/aiacemed/${id}/v1`;
      const response = await axios.put(url, data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch({ type: UPDATE_PROMPT_SUCCESS, payload: response.data });
      toast.success("Prompt updated successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      navigate("/prompts/list");
    } catch (error) {
      console.error(error);
      dispatch({ type: UPDATE_PROMPT_FAILURE, payload: error.message });
      toast.error(error?.response?.data?.message || "Failed to update prompt", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
};

export const deletePrompt = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "IS_PROMPT_UPDATED" });
      dispatch({ type: DELETE_PROMPT_REQUEST });
      const url = `${BASE_URL}/aiacemed/${id}/v1`;
      const response = await axios.delete(url, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch({ type: DELETE_PROMPT_SUCCESS, payload: response.data });
      toast.success("Prompt deleted successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELETE_PROMPT_FAILURE, payload: error.message });
      toast.error(error?.response?.data?.message || "Failed to delete prompt", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
};
